// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-components-InternalPage-styles--root--LPup3 {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  padding-top: 40px;
  min-height: 100%;
  min-height: 100vh;
  width: 100%;
}

@media screen and (min-width: 768px) {

.src-components-InternalPage-styles--root--LPup3 {
    padding-top: 70px;
}

    .src-components-InternalPage-styles--root--LPup3.src-components-InternalPage-styles--noPadding--bX0h6 {
      padding-top: 0;
    }
  }

.src-components-InternalPage-styles--root--LPup3.src-components-InternalPage-styles--noPadding--bX0h6 {
    padding-top: 0;
  }

*::-ms-backdrop,
.src-components-InternalPage-styles--root--LPup3 {
  height: 100vh;
}

.src-components-InternalPage-styles--content--PDkSM {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.src-components-InternalPage-styles--content--PDkSM > *:not(footer) a,.src-components-InternalPage-styles--content--PDkSM [data-anchor] {
    color: #6674a6;
    color: var(--greyishBlue);
  }

.src-components-InternalPage-styles--content--PDkSM > :not(footer) a:not(.src-components-InternalPage-styles--does-not-exist--umR1F):hover,.src-components-InternalPage-styles--content--PDkSM [data-anchor]:hover,.src-components-InternalPage-styles--content--PDkSM > :not(footer) a:not(.src-components-InternalPage-styles--does-not-exist--umR1F):focus,.src-components-InternalPage-styles--content--PDkSM [data-anchor]:focus {
      color: #315efb;
      color: var(--primaryForeground);
    }

.src-components-InternalPage-styles--main--v1q99 {
  background-color: #f9fafb;
  background-color: var(--dimBackground);
}

@media screen and (min-width: 768px) {

.src-components-InternalPage-styles--main--v1q99 {
    display: flex;
    flex: 1 0 auto;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
}
  }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/InternalPage/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AAab;;AAXE;;AAXF;IAYI,iBAAiB;AAUrB;;IARI;MACE,cAAc;IAChB;EACF;;AAEA;IACE,cAAc;EAChB;;AAGF;;EAEE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AAWxB;;AATE;IAEE,cAAyB;IAAzB,yBAAyB;EAM3B;;AAJE;MAEE,cAA+B;MAA/B,+BAA+B;IACjC;;AAIJ;EACE,yBAAsC;EAAtC,sCAAsC;AASxC;;AAPE;;AAHF;IAII,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AAExB;EADE","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.root {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: stretch;\n  padding-top: 40px;\n  min-height: 100%;\n  min-height: 100vh;\n  width: 100%;\n\n  @media (--desktop) {\n    padding-top: 70px;\n\n    &.noPadding {\n      padding-top: 0;\n    }\n  }\n\n  &.noPadding {\n    padding-top: 0;\n  }\n}\n\n*::-ms-backdrop,\n.root {\n  height: 100vh;\n}\n\n.content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n\n  & > *:not(footer) a,\n  & [data-anchor] {\n    color: var(--greyishBlue);\n\n    &:hover,\n    &:focus {\n      color: var(--primaryForeground);\n    }\n  }\n}\n\n.main {\n  background-color: var(--dimBackground);\n\n  @media (--desktop) {\n    display: flex;\n    flex: 1 0 auto;\n    flex-direction: row;\n    justify-content: center;\n    align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-components-InternalPage-styles--root--LPup3`,
	"noPadding": `src-components-InternalPage-styles--noPadding--bX0h6`,
	"content": `src-components-InternalPage-styles--content--PDkSM`,
	"doesNotExist": `src-components-InternalPage-styles--does-not-exist--umR1F`,
	"main": `src-components-InternalPage-styles--main--v1q99`
};
module.exports = ___CSS_LOADER_EXPORT___;
